// Toasts a Download Center link when a data-export task completes (drops from the list).
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '@bettercomp/ui-components';
import { selectExportTasks } from 'redux/backgroundTasks/selectors';

import { showNotification } from '../common/function';
import { PATH } from '../common/constants';

export function useExportTaskCompleteEvent() {
  const router = useRouter();
  const exportTasks = useSelector(selectExportTasks);
  const [previousExportTasks, setPreviousExportTasks] = useState(exportTasks);

  const toastBody = useMemo(() => (
    <div>
      Your file is available for download in the <br />
      <Button
        type="link"
        onClick={() => router.push(PATH.DOWNLOADS)}
        data-testid="downloadCenterButton"
      >
        Download Center
      </Button>
    </div>
  ), [router]);

  useEffect(() => {
    if (previousExportTasks.length > exportTasks.length) {
      showNotification(toastBody as any, 'Export Available', 'success');
    }

    setPreviousExportTasks(exportTasks);
  }, [exportTasks, previousExportTasks.length, toastBody]);
}
